import { useEffect, useState } from 'react';

export type ToastKind = 'filled' | 'partial' | 'rejected' | 'info';

export type ToastMsg = {
  id: number;
  kind: ToastKind;
  title: string;
  detail?: string;
};

type Listener = (t: ToastMsg) => void;
const listeners = new Set<Listener>();
let nextId = 1;

/** Fire a toast from anywhere (API client included — no React needed). */
export function toast(t: { kind: ToastKind; title: string; detail?: string }): void {
  const msg: ToastMsg = { id: nextId++, ...t };
  for (const cb of listeners) cb(msg);
}

const AUTO_CLEAR_MS = 4000;

export function ToastHost() {
  const [toasts, setToasts] = useState<ToastMsg[]>([]);

  useEffect(() => {
    const cb: Listener = (t) => {
      setToasts((cur) => [...cur, t]);
      setTimeout(() => setToasts((cur) => cur.filter((x) => x.id !== t.id)), AUTO_CLEAR_MS);
    };
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  }, []);

  if (toasts.length === 0) return null;
  return (
    <div className="toast-host">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.kind}`}>
          <div className="toast-title">{t.title}</div>
          {t.detail ? <div className="toast-detail">{t.detail}</div> : null}
        </div>
      ))}
    </div>
  );
}
